import {prepareDate} from '@/utils'

export const initialState = {
  incomingFilters: {
    initial: true,
    state: 'active',
    delivery_type: 'all',
    type: 'all',
    register_book: 'all',
    is_expired: false,
    is_informational: false,
    is_classified: false,
    created_date_from: null,
    created_date_to: null,
    term_date_from: null,
    term_date_to: null,
    q: '',
    page: 1
  },
  outgoingFilters: {
    initial: true,
    state: 'active',
    delivery_type: 'all',
    type: 'all',
    is_expired: false,
    is_informational: false,
    is_classified: false,
    created_date_from: null,
    created_date_to: null,
    term_date_from: null,
    term_date_to: null,
    q: '',
    page: 1
  },
  appealFilters: {
    initial: true,
    state: 'active',
    type: 'all',
    delivery_type: 'all',
    applicant_type: 'all',
    applicant_region: '0',
    applicant_area: '0',
    is_expired: false,
    is_redirected: false,
    is_group_appeal: false,
    is_repeated_appeal: false,
    is_informational: false,
    is_classified: false,
    created_date_from: null,
    created_date_to: null,
    term_date_from: null,
    term_date_to: null,
    q: '',
    page: 1
  },
  commonFilters: {
    initial: true,
    state: 'all',
    is_expired: false,
    is_informational: false,
    is_classified: false,
    created_date_from: null,
    created_date_to: null,
    term_date_from: null,
    term_date_to: null,
    q: '',
    page: 1
  },
  assignmentFilters: {
    initial: true,
    list_mode: 'all',
    expiration: 'all',
    state: 'active',
    priority: 'none',
    type: 'none',
    source_type: 'none',
    based_on_docs: false,
    q: '',
    page: 1
  },
  taskFilters: {
    state: 'all',
    show_expired: true,
    analytic_dimension: null,
    period: null,
    expiration_period: null
  },
  dashboardFilters: {
    common_items: {
      by: null,
      isDesc: false
    },
    controlled_items: {
      by: null,
      isDesc: false
    },
    expired_items: {
      by: null,
      isDesc: false
    },
    in_process_items: {
      by: null,
      isDesc: false
    },
  }
};

export default {
  namespaced: true,
  state: {...initialState},
  getters: {
    prepareFilter: (state) => (filterSet) => {
      const filter = {...state[filterSet]};
      for (let [key, value] of Object.entries(filter)) {
        if (value instanceof Date) {
          filter[key] = prepareDate(value)
        } else if (value === 'none') {
          delete filter[key]
        }
      }
      return !filter.initial ? filter : {};
    }
  },
  mutations: {
    SET(state, data) {
      state[data[0]] = data[1]
      if (!data[2])
        state[data[0]].initial = false
    },
    RESET(state, key = false) {
      if (key)
        state[key] = initialState[key]
      else {
        for (let filter in initialState) {
          if (filter !== 'dashboardFilters')
            state[filter] = initialState[filter]
        }
      }
    },
  }
}
